import styles from './Loader.module.scss'

type Props = {

}

const Loader = (props: Props) => {
  return (
    <span className={styles.loader}/>
  )
}

export default Loader;